export enum CreateOrderFormKeys {
    BankBIK = 'create-order-bank-bik',
    BankName = 'create-order-bank-name',
    BankPaymentAccount = 'create-order-bank-account-number',
    BankCorrespondentAccount = 'create-order-bank-correspondent-number',
    ContactFirstName = 'create-order-contact-firstname',
    ContactLastName = 'create-order-contact-lastname',
    ContactMiddleName = 'create-order-contact-middlename',
    ContactPhone = 'create-order-contact-phone',
    ContactEmail = 'create-order-contact-email',
}
